import React from 'react';
import BackgroundBoxes from './BackgroundBoxes.jsx';

/**
 * PageHero3D: Interactive grid background hero section for sub-pages.
 * Features black background with colorful hover animations and gradient text.
 */
const PageHero3D = ({ title, subtitle, accent = '#e63946' }) => {
  return (
    <section className="page-hero-boxes">
      {/* Background Boxes Animation */}
      <div className="background-boxes-container">
        <div className="background-overlay"></div>
        <BackgroundBoxes />
      </div>

      {/* Content */}
      <div className="page-hero-content">
        <h1 className="page-hero-title-gradient">{title}</h1>
        {subtitle && <p className="page-hero-subtitle-white">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero3D;

